module.exports = __webpack_public_path__ + "static/media/Layer4.dfa31089.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Layer4.png
// module id = 56
// module chunks = 0